<template>
    <div>
        <template v-if="currentView === 'form'">
            <form-template remark @submit="proceed" :showLoader="loadingBankDetails">
                <div class="col-span-4 md:col-span-1">
                    <p class="text-smoke-dark text-sm">Account Number</p>
                </div>
                <div class="col-span-4 md:col-span-3">
                    <biller-input
                        placeholder="Input Account Number"
                        v-model="data.account_number"
                        type="number"
                        required
                    />
                </div>
                <div class="col-span-4 md:col-span-1">
                    <p class="text-smoke-dark text-sm">Beneficiary Bank</p>
                </div>
                <div class="col-span-4 md:col-span-3">
                    <div class="grid grid-cols-4 gap-3 w-full">
                        <template v-if="showBanks.length">
                            <div class="col-span-2 md:col-span-1" v-for="bank in showBanks" :key="bank.value">
                                <biller-radio
                                    @select="(val) => selectBank(val, bank)"
                                    :value="bank.name"
                                    :active="selectedBank.name === bank.name"
                                    class="flex items-center justify-center w-full"
                                >
                                    <div class="flex items-center justify-center w-full">
                                        <p
                                            :class="
                                                `text-sm ${
                                                    selectedBank.name === bank.name ? 'text-purple' : 'text-grey-300'
                                                }`
                                            "
                                        >
                                            {{ bank.name }}
                                        </p>
                                    </div>
                                </biller-radio>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-span-2 md:col-span-1" v-for="index in 3" :key="index">
                                <div
                                    class="flex items-center justify-center border rounded-lg px-4 py-8 h-16 bg-transparent border-snow-200 w-full"
                                >
                                    <div class="skeleton"></div>
                                </div>
                            </div>
                        </template>
                        <div class="col-span-2 md:col-span-1">
                            <others-drop-down
                                :otherItems="banks"
                                @selectedItem="selectOther"
                                :value="selectedOther.name || 'Others'"
                                :active="(selectedOther.name || 'Others') === selectedBank.name"
                                text="banks"
                            >
                                <template v-slot:selected>
                                    <template v-if="selectedOther.name !== undefined">
                                        <div class="flex items-center">
                                            <p class="text-xs text-grey-300">
                                                {{ selectedOther.name }}
                                            </p>
                                        </div>
                                    </template>
                                    <template v-else>
                                        Others
                                    </template>
                                </template>
                            </others-drop-down>
                        </div>
                    </div>
                </div>
                <div class="col-span-4 md:col-span-1">
                    <p class="text-smoke-dark text-sm">Amount</p>
                </div>
                <div class="col-span-4 md:col-span-3 relative">
                    <biller-input
                        placeholder="Input Amount"
                        largeValue
                        type="text"
                        :value="input"
                        @input="updateAmount"
                        required
                    >
                        <template v-slot:append>
                            <img src="@/assets/svg/naira-icon.svg" alt="Nigerian Naira icon" />
                        </template>
                    </biller-input>
                </div>
            </form-template>
        </template>
        <template v-else>
            <transfer-summary :data="data" :bank="selectedBank" @proceed="$emit('proceedTransfer', data)" />
        </template>
    </div>
</template>

<script>
import { formatAmount } from '@/util/formatAmount'
import OthersDropDown from '@/components/OthersDropdown'
import TransferSummary from '@/components/forms/TransferSummary'
import { getBankDetails } from '@/api/transfer'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        OthersDropDown,
        TransferSummary,
    },
    created() {
        this.getAllBanks()
    },

    data() {
        return {
            selectedBank: {},
            input: '',
            selectedOther: '',
            loadingBankDetails: false,
            data: {
                amount: 0,
                account_number: '',
                account_name: '',
                bank_id: '',
            },
        }
    },
    computed: {
        ...mapGetters('Banks', {
            banks: 'GET_BANKS',
        }),

        showBanks: {
            get: function() {
                return this.banks.slice(0, 3)
            },
        },

        currentView: function() {
            return this.$route.params.layout
        },
    },
    methods: {
        selectOther(item) {
            this.selectedOther = item
            this.selectedBank = item
            this.data.bank_id = item.id
        },

        updateAmount(val) {
            this.input = val.replace(/[^\d]/g, '')
            this.$forceUpdate()
        },

        selectBank(bank, details) {
            this.selectedBank = details
            this.data.bank_id = details.id
            this.selectedOther = ''
        },

        proceed(val) {
            if (this.data.bank_id) {
                this.data = Object.assign(this.data, val)
                this.loadingBankDetails = true
                getBankDetails(this.data.account_number, this.selectedBank.rubies_code)
                    .then((data) => {
                        this.data.account_name = data.data.data.accountName
                        this.loadingBankDetails = false
                        this.$router.push('/transfer/confirm')
                    })
                    .catch((err) => {
                        this.loadingBankDetails = false
                        let message
                        this.setError(false)
                        if (err.response.status === 500) {
                            message = err.response.data.message
                        }
                        this.setMessage(message)
                    })
            }else{
                this.setError(true)
                this.setWarning('warning')
                this.setMessage('Please select a bank')
            }
        },

        ...mapActions('Banks', {
            getAllBanks: 'FETCH_BANKS',
        }),

        ...mapActions('Message', {
            setMessage: 'SET_MESSAGE',
            setError: 'SET_MESSAGE_TYPE',
            setWarning: 'SET_WARNING',
        }),
    },

    watch: {
        input: function(newValue) {
            let val = newValue
                .toString()
                .split(',')
                .join('')
            this.data.amount = parseInt(val)
            this.input = formatAmount(val)
        },
    },
}
</script>

<style scoped>
.skeleton {
    width: 50px;
    height: 15px;
    border-radius: 10px;
    animation: pulse-bg 1s ease-in-out infinite normal both;
}
</style>
